window.addEventListener('load', () => {
    const options = { method: 'GET', headers: { accept: 'application/json' } };
    const shopUrl = Shopify.shop;
    const defaultImageUrl = `https://${shopUrl}/cdn/shop/t/1/assets/natoriplaceholder.png`;
    function debounce(func, delay) {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const formatPrice = (price) => {
        const number = parseFloat(price);
        const currency = window.theme.settings.money_with_currency_format.replace(/{{.*?}}/g, '');
        
        let locale;
         switch (currency) {
            case '€': 
                locale = 'de-DE';
                break;
            case 'CHF':
                locale = 'de-CH';
                break;
            case 'R$':
                locale = 'pt-BR';
                break;
            case '¥':
                locale = 'ja-JP';
                break;
            case '$':
            default:
                locale = 'en-US';
                break;
        }
    
        return number.toLocaleString(locale, { 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 2 
        });
    };
    
    document.querySelectorAll('.searchform').forEach(searchForm => {
        let lastSearchTerm = '';
        let searchSuggestion;
        let currentSearchTerm = '';
        const searchInput = searchForm.querySelector('fieldset input.search-field');
        const autocompleteTarget = searchForm.querySelector('#ss__autocomplete--target');

        searchInput?.addEventListener('input', () => {
            const inputSearch = searchInput.value.trim();
            if(inputSearch.length === 0){
                autocompleteTarget.innerHTML = '';
            }
        });
    
        if (searchInput && autocompleteTarget) {
            document.addEventListener('click', function(event) {
                if (!searchInput.contains(event.target) && !autocompleteTarget.contains(event.target)) {
                    autocompleteTarget.style.display = 'none';
                }
            });
    
            const handleInput = debounce(async (e) => {
                const newSearchTerm = searchInput.value.trim();
                autocompleteTarget.style.display = 'block';
                if (newSearchTerm !== lastSearchTerm) {
                    autocompleteTarget.innerHTML = '';
                    lastSearchTerm = newSearchTerm;
                    if (newSearchTerm.length >= 3) {
                        console.log(searchForm);
                        await loadSearchSuggest(searchForm, newSearchTerm);
                    } else if (newSearchTerm.length === 0) {
                        searchSuggestion = false;
                        autocompleteTarget.innerHTML = '';
                    }
                }
            }, 500);
    
            searchInput?.addEventListener('input', handleInput);
    
            // Function to update facets and results based on the search term
            async function updateFacetsAndResults(searchForm, searchTerm, suggestionTerm = false) {
              currentSearchTerm = searchTerm;

                const apiURL = `https://cr8s7s.a.searchspring.io/api/search/autocomplete.json?siteId=cr8s7s&resultsFormat=json&q=${encodeURIComponent(searchTerm)}&newKey=New%20Value&bgfilter.ss_available=1&bgfilter.ss_has_tags=1&resultsPerPage=3&page=1&redirectResponse=direct&excludedFacets=collection_handle&disableInlineBanners=true`;
                try {
                    const response = await fetch(apiURL, options);
                    const data = await response.json();
    
                    const facetsWrapper = searchForm.querySelector('.ss__autocomplete__facets');
                    const resultssubWrapper = searchForm.querySelector('.ss__autocomplete__results');
    
                    if (!data.results || data.results.length === 0) {
                        resultssubWrapper.textContent = `No results found for "${searchTerm}".`;
                        facetsWrapper.style.display = 'none';
                        const facetTermSuggest = searchForm.querySelector('.ss__autocomplete__terms');
                        facetTermSuggest.style.display = 'none';
                        throw new Error('No results found');
                    }
    
                    // Clear facets and results but keep suggestions
                    facetsWrapper.innerHTML = '';
                    resultssubWrapper.innerHTML = '';
    
                    // Process the first 3 facets
                    const facetsToShow = data.facets.slice(0, 3);
                    facetsToShow.forEach(facet => {
                        if (facet.label !== "collection_name" && facet.label !== "variant_price" && facet.label !== "ss_available" && facet.label !== "tags") {
                        
                            const facetWrapper = document.createElement('div');
                            facetWrapper.className = `ss__facet ss__facet--list ss__facet--${facet.field}`;
        
                            const dropdownWrapper = document.createElement('div');
                            dropdownWrapper.className = 'ss__dropdown';
        
                            const button = document.createElement('button');
                            button.className = 'ss__dropdown__button';
                            button.setAttribute('role', 'button');
        
                            const header = document.createElement('div');
                            header.className = 'ss__facet__header';
                            header.setAttribute('role', 'heading');
                            header.setAttribute('aria-level', '3');
                            header.textContent = facet.label.replace(/_/g, ' ');
                            button.appendChild(header);
        
                            const dropdownContent = document.createElement('div');
                            dropdownContent.className = 'ss__dropdown__content';
        
                            const facetList = document.createElement('ul');
                            facetList.className = 'ss__facet-list-options';
        
                            // Populate only the first 6 values of each facet
                            const valuesToShow = facet.values.slice(0, 6);
                            valuesToShow.forEach(value => {
                                const listItem = document.createElement('li');
                                const link = document.createElement('a');
                                link.href = `/search?q=${encodeURIComponent(searchTerm)}#/filter:${facet.field}:${encodeURIComponent(value.value)}`;
                                link.textContent = value.label;
                                link.setAttribute('aria-label', `Filter by ${facet.label} - ${value.label}`);
                                link.dataset.facetField = facet.field;  // Store facet field for later use
                                link.dataset.facetValue = value.value;  // Store facet value for later use
                                listItem.appendChild(link);
                                facetList.appendChild(listItem);
                            });
        
                            dropdownContent.appendChild(facetList);
                            dropdownWrapper.appendChild(button);
                            dropdownWrapper.appendChild(dropdownContent);
                            facetWrapper.appendChild(dropdownWrapper);
                            facetsWrapper.appendChild(facetWrapper);
                        }
                    });
    
                    // Handle search results
                    data.results.forEach(async result => {
                        const article = document.createElement('article');
                        article.className = 'ss__result ss__result--grid';
    
                        const imageWrapper = document.createElement('div');
                        imageWrapper.className = 'ss__result__image-wrapper';
    
                        const imageLink = document.createElement('a');
                        imageLink.href = result.url;
    
                        const image = document.createElement('img');
                        image.src = result.thumbnailImageUrl ? result.thumbnailImageUrl : defaultImageUrl;
                        image.alt = result.name;
                        image.loading = 'lazy';
    
                        imageLink.appendChild(image);
                        imageWrapper.appendChild(imageLink);
    
                        const detailsWrapper = document.createElement('div');
                        detailsWrapper.className = 'ss__result__details';
    
                        const title = document.createElement('div');
                        title.className = 'ss__result__details__title';
    
                        const titleLink = document.createElement('a');
                        titleLink.href = result.url;
                        titleLink.textContent = result.name;
    
                        title.appendChild(titleLink);
    
                        const price = document.createElement('div');
                        price.className = 'ss__result__details__pricing';
    
                        const priceValue = document.createElement('span');
                        priceValue.className = 'ss__price';
                        priceValue.textContent = await prodPriceData(result.uid);
    
                        price.appendChild(priceValue);
                        detailsWrapper.appendChild(title);
                        detailsWrapper.appendChild(price);
    
                        article.appendChild(imageWrapper);
                        article.appendChild(detailsWrapper);
                        resultssubWrapper.appendChild(article);
                    });

                } catch (err) {

                    console.error('updateFacetsAndResults error: ', err);
                    if(suggestionTerm){
                        await updateFacetsAndResults(searchForm, suggestionTerm);
                    }            
                }
            }
    
            // Function to update content results based on bgfilter (hovering facets)
            async function updateContentResultsWithFilter(searchForm, facetField, facetValue) {

                const apiURL = `https://cr8s7s.a.searchspring.io/api/search/autocomplete.json?siteId=cr8s7s&resultsFormat=json&q=${encodeURIComponent(currentSearchTerm)}&filter.${facetField}=${facetValue}&bgfilter.ss_available=1&bgfilter.ss_has_tags=1&resultsPerPage=3&page=1&redirectResponse=direct`;
    
                try {
                    const response = await fetch(apiURL, options);
                    const data = await response.json();
    
                    const resultssubWrapper = searchForm.querySelector('.ss__autocomplete__results');
                    resultssubWrapper.innerHTML = '';
    
                    data.results.forEach(async result => {
                        const article = document.createElement('article');
                        article.className = 'ss__result ss__result--grid';
    
                        const imageWrapper = document.createElement('div');
                        imageWrapper.className = 'ss__result__image-wrapper';
    
                        const imageLink = document.createElement('a');
                        imageLink.href = result.url;
    
                        const image = document.createElement('img');
                        // image.src = result.thumbnailImageUrl;
                        image.src = result.thumbnailImageUrl ? result.thumbnailImageUrl : defaultImageUrl;
                        image.alt = result.name;
                        image.loading = 'lazy';
    
                        imageLink.appendChild(image);
                        imageWrapper.appendChild(imageLink);
    
                        const detailsWrapper = document.createElement('div');
                        detailsWrapper.className = 'ss__result__details';
    
                        const title = document.createElement('div');
                        title.className = 'ss__result__details__title';
    
                        const titleLink = document.createElement('a');
                        titleLink.href = result.url;
                        titleLink.textContent = result.name;
    
                        title.appendChild(titleLink);
    
                        const price = document.createElement('div');
                        price.className = 'ss__result__details__pricing';
    
                        const priceValue = document.createElement('span');
                        priceValue.className = 'ss__price';
                        priceValue.textContent = await prodPriceData(result.uid);
    
                        price.appendChild(priceValue);
                        detailsWrapper.appendChild(title);
                        detailsWrapper.appendChild(price);
    
                        article.appendChild(imageWrapper);
                        article.appendChild(detailsWrapper);
                        resultssubWrapper.appendChild(article);
                    });

                } catch (err) {

                    console.error('updateContentResultsWithFilter error: ',err);
                }
            }
    
    
            async function loadSearchSuggest(searchForm, searchTerm) {

                // Fetch query suggestions and alternatives
                const apiSuggetUrl = `https://cr8s7s.a.searchspring.io/api/suggest/query?siteId=cr8s7s&q=${searchTerm}&language=en&suggestionCount=5&productCount=3`;
                try {
                    const response = await fetch(apiSuggetUrl, options);
                    const suggestData = await response.json();
    
                    const container = searchForm.querySelector('#ss__autocomplete--target');
    
                    // Create the autocomplete wrapper if not already present
                    let autocompleteWrapper = container.querySelector('.ss__autocomplete.ss-pwahfn');
                    if (autocompleteWrapper) {
                        autocompleteWrapper.innerHTML = '';
                    } else {
                        autocompleteWrapper = document.createElement('div');
                        autocompleteWrapper.className = 'ss__autocomplete ss-pwahfn';
                        container.appendChild(autocompleteWrapper);
                    }
    
                    // Create the terms wrapper (for suggestions)
                    const termsWrapper = document.createElement('div');
                    termsWrapper.className = 'ss__autocomplete__terms';
    
                    const termssuggest = document.createElement('div');
                    termssuggest.className = 'ss__autocomplete__terms__suggestions';
    
                    const termsoptions = document.createElement('div');
                    termsoptions.className = 'ss__autocomplete__terms__options';
    
                    termsWrapper.appendChild(termssuggest);
                    termssuggest.appendChild(termsoptions);
    
                    // Handle the exact match suggestion
                    const exactSuggestion = suggestData.suggested.text;
                    searchSuggestion = exactSuggestion;
                    if (exactSuggestion) {
                        const exactDiv = document.createElement('div');
                        exactDiv.className = 'ss__autocomplete__terms__option ss__autocomplete__terms__option--active';
    
                        const exactLink = document.createElement('a');
                        exactLink.href = `https://${shopUrl}/search?q=${encodeURIComponent(exactSuggestion)}`;
                        exactLink.setAttribute('role', 'link');
                        exactLink.setAttribute('aria-label', `item 1 of 5, ${exactSuggestion}`);
                        exactLink.textContent = exactSuggestion;
    
                        exactDiv.appendChild(exactLink);
                        termsoptions.appendChild(exactDiv);
    
                        // Add hover functionality
                        const handleExactMouseEnter = debounce(async () => {
                            searchForm.querySelectorAll('.ss__autocomplete__terms__option').forEach(el => el.classList.remove('ss__autocomplete__terms__option--active'));
                            exactDiv.classList.add('ss__autocomplete__terms__option--active');
                            await updateFacetsAndResults(searchForm, exactSuggestion);
                        }, 700);
                        exactDiv.addEventListener('mouseenter', handleExactMouseEnter);
                    }
    
                    // Handle alternative suggestions (up to 5)
                    const alternatives = suggestData.alternatives.slice(0, 5);
                    alternatives.forEach((alternative, index) => {
                        const alternativeDiv = document.createElement('div');
                        alternativeDiv.className = 'ss__autocomplete__terms__option';
    
                        const alternativeLink = document.createElement('a');
                        alternativeLink.href = `https://${shopUrl}/search?q=${encodeURIComponent(alternative.text)}`;
                        alternativeLink.setAttribute('role', 'link');
                        alternativeLink.setAttribute('aria-label', `item ${index + 2} of 5, ${alternative.text}`);
                        alternativeLink.textContent = alternative.text;
    
                        alternativeDiv.appendChild(alternativeLink);
                        termsoptions.appendChild(alternativeDiv);
    
                        // Add hover functionality
                        const handleAlternativeMouseEnter = debounce(() => {
                            document.querySelectorAll('.ss__autocomplete__terms__option').forEach(el => el.classList.remove('ss__autocomplete__terms__option--active'));
                            alternativeDiv.classList.add('ss__autocomplete__terms__option--active');
                            updateFacetsAndResults(searchForm, alternative.text);
                        }, 500);
                        alternativeDiv.addEventListener('mouseenter', handleAlternativeMouseEnter);
                    });
    
                    // Append terms to the autocomplete wrapper
                    autocompleteWrapper.prepend(termsWrapper); // Add the suggestions above facets and results
    
                    // Create initial facets and results wrapper
                    const facetsWrapper = document.createElement('div');
                    facetsWrapper.className = 'ss__autocomplete__facets';
                    const resultContentWrapper = document.createElement('div');
                    resultContentWrapper.className = 'ss__autocomplete__content';
                    const resultsWrapper = document.createElement('div');
                    resultsWrapper.className = 'ss__autocomplete__content__results';
                    const resultssubWrapper = document.createElement('div');
                    resultssubWrapper.className = 'ss__results ss__results-grid ss__autocomplete__results ss-q1e55l';
                    resultsWrapper.appendChild(resultssubWrapper);
    
                    resultContentWrapper.appendChild(resultsWrapper);
                    // Append them to the autocomplete wrapper
                    autocompleteWrapper.appendChild(facetsWrapper);
                    autocompleteWrapper.appendChild(resultContentWrapper);
    
                    // Add hover functionality to facet options
                    const handleMouseOver = debounce(async (event) => {
                        const facetLink = event.target.closest('.ss__facet-list-options a');
                        if (facetLink) {
                            const facetField = facetLink.href.split('/filter:')[1].split(':')[0];  // Extract facet field from URL
                            const facetValue = facetLink.href.split('/filter:')[1].split(':')[1];  // Extract facet value from URL
                            await updateContentResultsWithFilter(searchForm, facetField, facetValue); // Call the update function with filter
                        }
                    }, 700);
    
                    document.addEventListener('mouseover', handleMouseOver);
    
                    await updateFacetsAndResults(searchForm, searchTerm, searchSuggestion);
                } catch (err) {
                    console.error('loadSearchSuggest error : ',err);
                }
            }

            const prodPriceData = async (id) => {
                const storefrontAccessToken = window.storefrontAccessToken;
                const url = `https://${shopUrl}/api/2024-10/graphql.json`;
                const productId = `gid://shopify/Product/${id}`; 
                const productQuery = `
                    query getProductById($id: ID!, $country: CountryCode) @inContext(country: $country) {
                        product(id: $id) {
                            id
                            title
                            handle
                            priceRange {
                                maxVariantPrice {
                                    amount
                                    currencyCode
                                }
                                minVariantPrice {
                                    amount
                                    currencyCode
                                }
                            }
                        }
                    }
                `;
            
                try {
                    const response = await fetch(url, {
                        method: "POST",
                        headers: {
                            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: productQuery,
                            variables: {
                                id: productId,  // Use GID here
                                country: Shopify.country
                            }
                        })
                    });
            
                    const { data, errors } = await response.json();
            
                    if (errors) {
                        console.error('GraphQL Errors:', errors);
                        return null;
                    }
            
                    if (data && data.product) {
                        const minPrice = data.product.priceRange.minVariantPrice.amount;
                        const maxPrice = data.product.priceRange.maxVariantPrice.amount;
            
                        let priceData;
                        if (maxPrice > minPrice) {
                            priceData = `${currencySuggestFormat}${formatPrice(minPrice)} - ${currencySuggestFormat}${formatPrice(maxPrice)}`;
                        } else {
                            priceData = `${currencySuggestFormat}${formatPrice(maxPrice)}`;
                        }
            
                        return priceData;
                    } else {
                        console.warn("No product data found.");
                        return null;
                    }
            
                } catch (error) {
                    console.error("Error fetching product:", error);
                    throw error;
                }
            };
            
        }
    });
});